import { fade } from 'material-ui/utils/colorManipulator';
import spacing from 'material-ui/styles/spacing';
import { white } from 'material-ui/styles/colors';
import {
  primaryBlue,
  grayLight,
  grayMedium,
  grayDark,
  textColorGray,
  tableSelectedGray,
  tableHoverGray, purpleDecorations,
} from './mainColors';

export default {
  fontFamily: 'Roboto, sans-serif',
  spacing,
  tableHeaderColumn: {
    height: 40,
    spacing: 12,
    textColor: fade(grayMedium, 0.8)
  },
  tableRow: {
    height: 40,
    selectedColor: tableSelectedGray,
    hoverColor: tableHoverGray
  },
  tableRowColumn: {
    height: 40,
    spacing: 12
  },
  checkbox: {
    checkedColor: primaryBlue
  },
  palette: {
    accent1Color: primaryBlue,
    textColor: textColorGray,
    secondaryColor: purpleDecorations,
    secondaryTextColor: white,
    neutralColors: {
      white: white,
      light: grayLight,
      normal: grayMedium,
      dark: grayDark
    },
    accentColors: {
      blue: primaryBlue,
    }
  },
  raisedButton: {
    labelStyle: {
      fontSize: 13
    }
  },
  flatButton: {
    labelStyle: {
      fontSize: 13
    }
  }
};



// WEBPACK FOOTER //
// ./src/theme/mainTheme.js